import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { CreateTimelinePayload } from 'views/DealDashboard/Overview/Timeline/types';

export const createTimeline = async ({ orgId, dealId, postData }: { orgId: string; dealId: number; postData: CreateTimelinePayload }) => {
    const response = await axiosInstance.post(API_ENDPOINTS.TIMELINES(orgId, dealId), postData);
    return response.data;
};

export const useCreateTimeline = () => useMutation({
    mutationFn: createTimeline,
});
